import React, { useEffect, useState } from "react";
import { Table, Button, message, Space } from "antd";
import SummaryApi from "../../../common/index";
import axios from "axios";

const SellersTable = ({ status }) => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch sellers by status
  const fetchSellers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("adminToken");
      const res = await axios({
        method: SummaryApi.getSellersByStatus(status).method,
        url: SummaryApi.getSellersByStatus(status).url,
        headers: { Authorization: `Bearer ${token}` },
      });
      setSellers(res.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Fetch sellers error:", err);
      message.error("Failed to fetch sellers");
    }
  };

  useEffect(() => {
    fetchSellers();
  }, [status]);

  // Approve / Reject seller
  const handleAction = async (id, action) => {
    const token = localStorage.getItem("adminToken");
    try {
      await axios({
        method: SummaryApi.getUpdateSellerStatus(id).method,
        url: SummaryApi.getUpdateSellerStatus(id).url,
        headers: { Authorization: `Bearer ${token}` },
        data: { action },
      });
      message.success(`Seller ${action} successfully`);
      fetchSellers();
    } catch (err) {
      console.error("Action error:", err);
      message.error("Action failed");
    }
  };

  // Define table columns
  const columns = [
    {
    title: "S.No",
    key: "sno",
    render: (text, record, index) => index + 1, // row index + 1
    width: 70,
  },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Store Name", dataIndex: "store_name", key: "store_name" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => text.charAt(0).toUpperCase() + text.slice(1),
    },
  {
      title: "Document",
      dataIndex: "identity_proof",
      key: "identity_proof",
      render: (fileName) =>
        fileName ? (
          <Button
            type="link"
            onClick={() =>
              window.open(
                `${process.env.REACT_APP_BACKEND_URL}${fileName}`,
                "_blank"
              )
            }
          >
            View Document
          </Button>
        ) : (
          "No document"
        ),
      }
      ]

  // ✅ Actions column
  columns.push({
    title: "Actions",
    key: "actions",
    render: (_, record) => {
      if (status === "pending") {
        return (
          <Space>
            <Button
              type="primary"
              onClick={() => handleAction(record.id, "approve")}
            >
              Approve
            </Button>
            <Button style={{color:"#ee152d"}} onClick={() => handleAction(record.id, "reject")}>
              Reject
            </Button>
          </Space>
        );
      }
      if (status === "approve") {
        return (
          <Button danger onClick={() => handleAction(record.id, "reject")}>
            Reject
          </Button>
        );
      }
      if (status === "reject") {
        return (
          <Button type="primary" onClick={() => handleAction(record.id, "approve")}>
            Approve
          </Button>
        );
      }
      return null;
    },
  });

  return (
    <Table
      rowKey="id"
      dataSource={sellers}
      columns={columns}
      loading={loading}
    />
  );
};

export default SellersTable;
